export class ContactRole {
  constructor() {
    this.id = "";
    this.name = "";
    this.createdBy = "";
  }
}
